export default __webpack_public_path__ + "static/media/background.850c7ccd.png";